module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-5_BW-p-130x130q80-7ce160b5896aa46fd371d0c03d473338.jpg";